import {$CC, ASIA_COUNTRIES, ALL_COUNTRIES, MapDifficultyLevel} from "../types";

// function print() {
//   const codes: string[] = []
//   for (const name of [
// "Afghanistan","Armenia","Bangladesh","Bhutan","Brunei Darussalam","Cambodia","China","India","Indonesia","Iran","Iraq","Israel","Japan","Jordan","Kazakhstan","Kuwait","Kyrgyz Republic", "Lao People's Democratic Republic","Lebanon","Malaysia","Maldives","Mongolia","Myanmar","Nepal","North Korea","Oman","Pakistan","Philippines","Qatar","Russia","Saudi Arabia","South Korea","Sri Lanka","Syrian Arab Republic","Taiwan","Tajikistan","Thailand", "Timor-Leste","Turkey","Turkmenistan","United Arab Emirates","Uzbekistan","Vietnam", "Yemen",
//   ]) {
//     console.log(name);
//     const country = ALL_COUNTRIES.find(c => c.name === name);
//     codes.push(`$CC("${country.cc}")`);
//   }
//   console.log(codes.join(", "));
// }
// print();
export class AsiaDifficultyLevel extends MapDifficultyLevel {

  static readonly VALUES = new Array<AsiaDifficultyLevel>(1);
  static readonly MEDIUM = AsiaDifficultyLevel.VALUES[0] = new AsiaDifficultyLevel("medium", "Medium", "Medium desc", ASIA_COUNTRIES);
}